<template>
  <div id="app">
    <div v-if="appStyle.Desktop" class="full-height d-flex flex-column bg-white" :dir="hebrew ? 'rtl' : 'ltr'">
      <headers :global-modes-obj="globalModesObj" v-on:show-keyboard-shortcuts="showKeyboardShortcuts"></headers>
      <router-view class="main-content-height-plus"
                   :global-modes-obj="globalModesObj"
                   v-bind:class="{
                     'main-content-padding': $route.name !== 'Projects'
                   }"
                   v-on:show-keyboard-shortcuts="showKeyboardShortcuts">
        <template v-slot:buttons-after-dropbox-logout
                  v-if="$route.name === 'Projects' && enableFullServerRefresh">
            <b-button 
            variant="outline-primary"
            class="mx-3 px-4"
            @click="runFullServerRefresh">
                איתחול פרוייקט שלם מחדש (יכול לקחת הרבה זמן!)
            </b-button>
        </template>
      </router-view>
      <div id="change-password-msg" class="notify-msg variable-height-msg" style="display:none;">
        <p class="f white">text will be filled in by code</p>
      </div>
      <div id="text-load-msg" class="notify-msg" style="display:none; text-align: center">
          <p>הטקסט נטען בהצלחה</p>
      </div>
      <keyboard-shortcuts-container :show-shortcuts-obj="showShortcutsObj" />
    </div>
    <div v-if="appStyle.Mobile" class="d-block text-white h-100 text-center bg-primary">
      <div class="logo-holder"><img class="logo" src="@/assets/logo.png"></div>
      <h2 class="f-narkis py-5">
        המפענח ראשי תיבות אינו זמין בנייד.
      </h2>
    </div>
    <server-update-status-popup />
    <spinner v-if="loading" />
  </div>
</template>

<script>
import $ from 'jquery'
import headers from './components/headers'
import KeyboardShortcutsContainer from './components/KeyboardShortcutsContainer'
import ServerUpdateStatusPopup from '@/components/ServerUpdateStatusPopup'
import {AppConfig} from './appConfig'
import triggerServerUpdate from './js/triggerServerUpdate'
import Spinner from 'shared/components/spinner'
import {RunStates} from './store/runStates'
import {AppStyle} from '@/mobileVsDesktop'

export default {
  components: {
    headers,
    KeyboardShortcutsContainer,
    ServerUpdateStatusPopup,
    Spinner
  },
  name: 'App',
  data () {
    return {
      globalModesObj: {
        allowLeaving: false
      },
      showShortcutsObj: {
        showShortcuts: false
      }
    }
  },
  methods: {
    getCookie(cname) {
      var name = cname + '='
      var ca = document.cookie.split(';')
      for(var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) == ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length)
        }
      }
      return ''
    },          
    showKeyboardShortcuts() {
      this.showShortcutsObj.showShortcuts = true
    },
    multiModal() {
      $(document).on('show.bs.modal', '.modal', function () {
        var zIndex = 1040 + (10 * $('.modal:visible').length);
        $(this).css('z-index', zIndex);
        setTimeout(function () {
          $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
        }, 0);
      });
    },
    runFullServerRefresh () {
      triggerServerUpdate({ fullrefresh: true })
    }
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },
    appStyle () {
      return AppStyle
    },
    enableFullServerRefresh () {
      const abbrevProjectSettings = this.$store.state.dropbox?.projectSettings?.abbreviation
      return AppConfig.SERVER_UPDATE.ENABLE_FULL_REFRESH
        && (abbrevProjectSettings
            || AppConfig.SERVER_UPDATE.USE_OLD_HARD_CODED_TALMUD_VERSION)
    },
    loading () {
      return this.$store.state.nakdanApiState === RunStates.RUNNING
              || this.$store.state.genreClassifyApiState === RunStates.RUNNING
    }
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search)
    const lang = urlParams.get('lang')
    if (this.getCookie('DICTA_USE_HEBREW') !== '') {
      this.$settings.hebrew = (this.getCookie('DICTA_USE_HEBREW') === 'true')
    } else if (lang !== null) {
      this.$settings.hebrew = lang.includes('he')
    } else {
      this.$settings.hebrew = true
    }
    if (this.$settings.hebrew) {
      document.body.classList.add('he')
    } else {
      document.body.classList.remove('he')
    }
    if (AppStyle.Mobile) document.body.classList.add('mobile')
  },
  mounted() {
    this.multiModal();
  }
}
</script>

<style lang="scss">
    .bg-background {
      background: #f6f6f6;
    }

    .he .custom-control {
        padding-left: 0;
        padding-right: 1.5rem;
    }

    .he .custom-control-label:after, .he .custom-control-label:before {
        left: initial;
        right: -1.5rem;
    }

    @font-face {
        font-family: 'mfw_korentanakh_bold';
        src: url('assets/fonts/KorenTanakh-bold_MFW_FixedQQ.woff') format('woff');
        font-style: normal;
        font-weight: normal;
    }

    @font-face {
        font-family: 'mft_narkisclassic';
        src: url('assets/fonts/mft_narkisclassic-regular.woff') format('woff');
        font-style: normal;
        font-weight: normal;
    }

    @font-face {
        font-family: mft_narkisclassic;
        src: url('assets/fonts/MFTW_NarkisClassicBold.woff') format('woff');
        font-style: normal;
        font-weight: bold;
    }

    .f-narkis {
        font-family: Roboto, mft_narkisclassic, sans-serif;
        line-height: 1.5;
    }

    .f-koren {
        font-family: mfw_korentanakh_bold;
    }

    .home {
        margin-top: 20px;
        margin-bottom: 20px;
    }

    #app {
        height: 100vh;
        display: flex;
        flex-direction: column;
        background: #F6F6F6;
        z-index: 1;
    }

    .mobile-landscape {
        display: none;
    }

    /* Smartphones (landscape) ----------- */
    @media only screen and (min-device-width: 320px) and (max-device-width: 568px)
    and (-webkit-device-pixel-ratio: 2) and (device-aspect-ratio: 40/71) and (orientation:landscape)
    { 
        .mobile-landscape {
            display: block!important;
            visibility: visible!important;
        }
        #app {
            display: none;
        }
    }    
    @media (orientation: landscape) {
        .mobile .mobile-landscape {
            display: block;
            visibility: visible!important;
        }
        .mobile #app {
            display: none;
        }
        body.position-fixed.mobile {
            position: unset !important;
        }
    }
    .notify-msg {
        position: fixed;
        right: 24px;
        bottom: 48px;
        width: 238px;
        height: 50px;
        padding: 15px 8px;
        text-align: center;
        border-radius: 3px;
        box-sizing: border-box;
        background-color: #494949;
        z-index: 1;
        @media (max-width: 767px) {
          right: auto;
          left:10px;
          height: auto;
          padding: 12px 8px;
        }
    }

    .variable-height-msg {
        height: unset !important;
    }

    .notify-msg p{
        margin: 0;
        color: white;
    }

    .main-content-height-plus {
      min-height: 100px;
      flex: auto;
      height: calc(100% - 40px) !important;
      @media (max-width: 991px) {
          overflow: auto
      };
    }

    .main-content-padding {
      padding: 30px 15px;
    }
/* note: this section, and the second "possibility" in the next section, are not present in the Nakdan */
    .download-popup .dropdown-toggle,  .download-popup .dropdown-menu {
        width: 200px;
        right: 0;
    }

    .nikud-pane-container .dropdown, .download-popup .dropdown {
        margin-top: 0;
    }
   .login-dropdown-menu{
        min-width: 15rem;
    }
    .settings-button {
        float: left;
    }

    a.clickable-link {
        margin:0 0 0 14px;
        color: black;
        text-decoration: underline;
    }
    
/* note: this section's not in the Nakdan or abb-dev (and the previous section defines slightly different margins */
    .he a.clickable-link {
        margin:0 14px 0 0;
    }

    a.clickable-link:hover {
        color: black;
        text-decoration: underline;
    }

    a.clickable-link:focus {
        color: black;
        text-decoration: underline;
    }

    .options-account-needed-popup, .manual-nikud-account-needed-popup, .copy-options-popup {
        position: absolute;
        z-index: 2;
        border-color: transparent;
        font-size: 14px;
        border-radius: 2px;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
        background-color: #ffffff;
    }
    .options-account-needed-popup, .manual-nikud-account-needed-popup {
        font-family: Roboto,Arimo;
        padding: 8px;
        margin-right: 1px;
        margin-left: 4px;
        bottom: 80px; /* the one for "options" will be changed dynamically */
    }

/* note: the settings in the next three sections are not present in the shared Nakdan */
    .download-popup, .prompt-popup {
        position: absolute;
        left: 450px;
        top: 20%;
        z-index: 20;
        background-color: white;
        padding: 0 0 8px;
        border-style: solid;
        border-color: gray;
    }

    .download-popup {
        height: 250px;
        width: 400px;
        left: 250px;
    }

    .prompt-popup {
        height: 160px;
        width: 250px;
        padding: 5px;
    }

    .apply-to-all-popup p, .download-popup p {
        padding-right: 8px;
        margin-bottom: 6px;
    }

    .apply-to-all-popup button, .download-popup button {
        margin: 0 0 8px 8px;
    }

/* note: this section is not present in the Nakdan */
    .bottom-of-popup {
        position: absolute;
        bottom: 0;
        left: 0;
    }

    #failed-validation-modal, .failed-validation-footer, 
    #go-home-modal, .go-home-footer, 
    #switch-genre-modal .switch-genre-footer, 
    #text-too-long-modal, .text-too-long-footer {
        justify-content: center;
    }

    .failed-validation-footer .btn {
        width: 50%;
    }

    .failed-validation-footer, 
    .go-home-footer, 
    .switch-genre-footer, 
    .text-too-long-footer,
    .apply-to-all-footer {
        border-top: 1px solid #e3e3e3;
        direction: rtl; // so cancel button is ALWAYS on the right
        >:not(:last-child) { // ALWAYS "hebrew" style (because of the above)
            margin-left: .25rem;
            margin-right: 0;
        }
        >:not(:first-child) {
            margin-left: 0;
            margin-right: .25rem;
        }
    }

    body:not(.he) .apply-to-all-footer {
        justify-content: right; // otherwise, the direction will justify left
    }

    #go-home-modal .go-home-footer .btn,
    #switch-genre-modal .switch-genre-footer .btn,
    #text-too-long-modal .text-too-long-footer .btn {
        width: 100%;
    }

    .scroll-modal {
        height: 70vh;
        overflow: auto;
    }

    .fa-star {
        color: #68B8F8;
    }

    .pointer {
        cursor: pointer;
    }

    .popover {
        text-align: right;
        -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
        left: -5px !important;
        border: 0;
        max-width: 270px;
        margin-bottom: 4px;
    }
    .popover .arrow {
        display: none;
    }
    .popover-body {
        padding: 1rem;
    }

    .dictionary-button {
        border-radius: 15px;
        padding: 1px;
        width: 16px;
        height: 16px;
        text-align: center;
        margin-right: 2px;
        color: #989a97 !important;
        font-size: 10px;
        display: inline-block;
        vertical-align: middle;
        line-height: 1.5;
    }
    .bordered-footer {
      padding: 12px;
      border-top: solid 1px rgba(0, 0, 0, 0.1);
    }
    .dictionary-button:hover {
        background: #F6F6F6;
    }

    .full-height {
        height: 100%;
    }
    .accordion-header {
        background-color: white;
        border-bottom: 0;
        padding: 0;
        height: 28px;
        border-radius: 4px;
    }

    .accordion-toggle-btn {
        background: white;
        border: 0;
        text-align: right;
        height: 100%;
        color: #000;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        border-radius: 4px;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
    }

    .accordion-toggle-btn:not(:disabled):not(.disabled):hover,
    .accordion-toggle-btn:not(:disabled):not(.disabled):active,
    .accordion-toggle-btn:not(:disabled):not(.disabled).active,
    .accordion-toggle-btn:not(:disabled):not(.disabled)[aria-expanded="true"] {
        background-color: #f6f6f6;
        outline: none;
        color: #007EE5;
        border-radius: 4px 4px 0 0;
    }
    .accordion-toggle-btn:not(:disabled):not(.disabled):active,
    .accordion-toggle-btn:not(:disabled):not(.disabled).active,
    .accordion-toggle-btn:not(:disabled):not(.disabled)[aria-expanded="true"] {
        box-shadow: none !important;
    }

    .tooltip-inner {
        white-space: nowrap;
    }
    @media (max-width: 991px) {
        .container {
            max-width: 100%;
        }
    }
    .modal-backdrop:not(.show):not(.fade) {
        opacity: 0.2;
    }
    @media (max-width: 991px) {
        body,#app{
            min-height:100%;
            width: 100%;
            left:0;
        }        
    }
</style>
<style scoped>
  .logo-holder {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 40px;
    width: 80px;
    height: 80px;
    background-color: white;
    margin: 100px 0 10px;
  }
  .logo {
    height: 50px;
  }
  body div{direction: ltr;text-align: left;}
  body.he div{direction: rtl;text-align: right;}
</style>

